import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import AnswerCardDialog, { PENDING_CARD } from "../components/AnswerCardDialog";
import { getCardCheckoutStatus } from "../lib/api";

export default function CardSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const id = params.get("session_id");
  const [pending] = useState(() => { try { return JSON.parse(localStorage.getItem(PENDING_CARD)); } catch { return null; } });
  const [state, setState] = useState(params.get("canceled") || !id ? "canceled" : "checking");
  const back = () => { localStorage.removeItem(PENDING_CARD); navigate(pending?.back || "/", { replace: true }); };

  useEffect(() => {
    if (state !== "checking") return undefined;
    let tries = 0;
    let alive = true;
    const poll = async () => {
      try {
        const s = await getCardCheckoutStatus(id);
        if (!alive) return;
        if (s.status === "paid" || s.status === "used") return setState("paid");
      } catch { /* retry */ }
      tries += 1;
      if (tries < 20) setTimeout(poll, 2000); else setState("timeout");
    };
    poll();
    return () => { alive = false; };
  }, [id, state]);

  return (
    <main data-testid="card-success-page" className="min-h-[100dvh] bg-[#f8faf8] grid place-items-center px-5 text-center">
      <div className="max-w-sm">
        <img src="/brand/phdg-logo.png" alt="GreenFlow Plant Health & Diagnostic Group" className="mx-auto w-44 h-auto" />
        {state === "checking" && <p className="mt-6 text-slate-700 flex items-center justify-center gap-2"><Loader2 className="animate-spin" size={18} />Confirming your $1 payment with Stripe…</p>}
        {state === "paid" && <p data-testid="card-paid" className="mt-6 text-slate-700">Payment confirmed. Your card is being prepared…</p>}
        {state === "canceled" && <p data-testid="card-canceled" className="mt-6 text-slate-700">No charge was made.</p>}
        {state === "timeout" && <p className="mt-6 text-slate-700">We couldn't confirm the payment yet. If you were charged, return to your chat and tap the button again; your paid card will be waiting.</p>}
        <Button data-testid="card-back-button" onClick={back} variant="outline" className="mt-6 rounded-xl h-11">Back to my chat</Button>
      </div>
      {state === "paid" && pending && <AnswerCardDialog answer={pending} sessionId={pending.sessionId} onClose={back} />}
    </main>
  );
}
